var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Enemy', {
    attrs: {
      "id": _vm.random.m_QuestEnemyIDs[_vm.selected],
      "level": _vm.random.m_QuestEnemyLvs[_vm.selected],
      "qid": _vm.qid
    }
  }), _c('v-select', {
    staticClass: "px-4 px-sm-2",
    attrs: {
      "items": _vm.enemies,
      "dense": ""
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }